import React from 'react';
import MultipleAddedCouponsAction from "@/Pages/Coupons/Assets/MultipleAddedCouponsAction/MultipleAddedCouponsAction";

const AddedCouponBottomPanel = ({handleCheckAll, checked, parentCheckbox}) => {

  return (
    <tfoot className='border-t'>
    <tr>
      <td className="px-1 pt-5 pb-4 w-1">
        <input type="checkbox" onChange={handleCheckAll} ref={parentCheckbox} defaultChecked={false}/>
      </td>
      <td>
        <MultipleAddedCouponsAction checked={checked}/>
      </td>
    </tr>
    </tfoot>
  );
};

export default AddedCouponBottomPanel;
